import { BarChart3 } from "lucide-react";
import { ObservabilityLayout } from "@/components/organisms/observability/ObservabilityLayout";
import { PageHeader } from "@/components/molecules/PageHeader";

export function ObservabilityPage() {

  return (
    <div className="flex h-full flex-col gap-4 animate-fade-in bg-background">
      <PageHeader icon={BarChart3} title="Observability" description="Agent, tool, and service health from the metrics tables" />
      <div className="flex-1 min-h-0 overflow-y-auto">
        <ObservabilityLayout />
      </div>
    </div>
  );
}

export default ObservabilityPage;
